export const compact = (arr = []) => arr.filter((x) => x != null);
//# sourceMappingURL=compact.js.map